unable to read source [project]/momira.app/web/node_modules/src/ui/scanner/file-selection-ui.ts